import { render, staticRenderFns } from "./AidocLogin.vue?vue&type=template&id=c48afcae&scoped=true"
import script from "./AidocLogin.vue?vue&type=script&lang=js"
export * from "./AidocLogin.vue?vue&type=script&lang=js"
import style0 from "./AidocLogin.vue?vue&type=style&index=0&id=c48afcae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48afcae",
  null
  
)

export default component.exports